

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react'; // Menu aur X icon import kiya mobile ke liye

const Navbar = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Mobile menu ki state

  const navigate = useNavigate();

  // Navigation function
  const handleProductClick = (category) => {
    navigate('/quote', { state: { category } });
    setProductOpen(false);
    setIsMobileMenuOpen(false); // Click hone par mobile menu close karein
  };

  // Mobile menu close karne ka helper function
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setProductOpen(false);
    setContactOpen(false);
  };

  return (
    <>
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            
            {/* <Link to="/" className="flex items-center space-x-2" onClick={closeMobileMenu}>
              {/* Logo Image */}
              {/* <img 
                src="/logo1.png" 
                alt="logo" 
                className="w-16 h-16 object-contain scale-100"
              /> */}

              {/* Logo Text */}
              {/* <div className="flex flex-col leading-tight">
                <span className="text-xl font-bold text-[#D4AF37] tracking-wide">
                  VIGYAN HEALTHCARE LLP
                </span>
                <span className="text-xs text-[#1FB6C9] -mt-1">
                  Mfg. of Pharmaceutical API and Chemicals
                </span>
              </div> */}
         {/* </Link> */} 




            <Link to="/" className="flex items-center" onClick={closeMobileMenu}>
  <img
    src="/logo3.png"
    alt="Vigyan Healthcare Logo"
    className="h-16 object-contain"
  />
</Link>

            {/* Desktop Navigation Links (Hidden on Mobile) */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-emerald-600 font-medium hover:text-emerald-700 transition-colors">
                Home
              </Link>

              {/* Product Dropdown (Desktop) */}
              <div className="relative">
                <button
                  onClick={() => {
                    setProductOpen(!productOpen);
                    setContactOpen(false);
                  }}
                  className="flex items-center space-x-1 text-gray-700 font-medium hover:text-emerald-600 transition-colors"
                >
                  <span>Product</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${productOpen ? 'rotate-180' : ''}`} />
                </button>

                {productOpen && (
                  <div className="absolute top-full mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 overflow-hidden">
                    {["Hormones", "Corticosteroids", "Vitamins", "Antibiotics"].map((item) => (
                      <button 
                        key={item}
                        onClick={() => handleProductClick(item)}
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors text-sm font-medium"
                      >
                        {item}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <Link to="/about" className="text-gray-700 font-medium hover:text-emerald-600 transition-colors">
                About Us
              </Link>

              {/* Contact Us Dropdown (Desktop) */}
              <div className="relative">
                <button
                  onClick={() => {
                    setContactOpen(!contactOpen);
                    setProductOpen(false);
                  }}
                  className="flex items-center space-x-1 text-gray-700 font-medium hover:text-emerald-600 transition-colors"
                >
                  <span>Contact Us</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${contactOpen ? 'rotate-180' : ''}`} />
                </button>
                {contactOpen && (
                  <div className="absolute top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2">
                    <Link to="/contact" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors">
                      Contact Form
                    </Link>
                    <a href="tel:+919630935265" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors">
                      Call Us
                    </a>
                  </div>
                )}
              </div>
            </div>

            {/* Hamburger Button (Visible ONLY on Mobile) */}
            <button 
              className="md:hidden text-gray-700 hover:text-emerald-600 transition-colors"
              onClick={() => setIsMobileMenuOpen(true)}
            >
              <Menu className="w-8 h-8" />
            </button>

          </div>
        </div>
      </nav>

      {/* --- MOBILE SIDEBAR SECTION --- */}
      
      {/* Background Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-50 md:hidden transition-opacity"
          onClick={closeMobileMenu}
        />
      )}

      {/* Sliding Drawer */}
      <div 
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out flex flex-col md:hidden ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close Button Header */}
        <div className="flex justify-end p-5 border-b border-gray-100">
          <button onClick={closeMobileMenu} className="text-gray-500 hover:text-red-500 transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Mobile Links */}
        <div className="flex flex-col p-6 space-y-6 overflow-y-auto">
          <Link 
            to="/" 
            className="text-gray-800 font-medium text-lg hover:text-emerald-600 transition-colors"
            onClick={closeMobileMenu}
          >
            Home
          </Link>

          {/* Product Dropdown (Mobile) */}
          <div className="flex flex-col">
            <button
              onClick={() => setProductOpen(!productOpen)}
              className="flex items-center justify-between text-gray-800 font-medium text-lg hover:text-emerald-600 transition-colors w-full text-left"
            >
              <span>Product</span>
              <ChevronDown className={`w-5 h-5 transition-transform ${productOpen ? 'rotate-180' : ''}`} />
            </button>
            {/* Mobile Dropdown Options (Accordion style) */}
            <div className={`flex flex-col space-y-3 mt-3 ml-4 overflow-hidden transition-all duration-300 ${productOpen ? 'max-h-48' : 'max-h-0'}`}>
              {["Hormones", "Corticosteroids", "Vitamins", "Antibiotics"].map((item) => (
                <button 
                  key={item}
                  onClick={() => handleProductClick(item)}
                  className="text-left text-gray-600 hover:text-emerald-600 transition-colors text-sm font-medium"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <Link 
            to="/about" 
            className="text-gray-800 font-medium text-lg hover:text-emerald-600 transition-colors"
            onClick={closeMobileMenu}
          >
            About Us
          </Link>

          {/* Contact Us Dropdown (Mobile) */}
          <div className="flex flex-col">
            <button
              onClick={() => setContactOpen(!contactOpen)}
              className="flex items-center justify-between text-gray-800 font-medium text-lg hover:text-emerald-600 transition-colors w-full text-left"
            >
              <span>Contact Us</span>
              <ChevronDown className={`w-5 h-5 transition-transform ${contactOpen ? 'rotate-180' : ''}`} />
            </button>
            {/* Mobile Dropdown Options (Accordion style) */}
            <div className={`flex flex-col space-y-3 mt-3 ml-4 overflow-hidden transition-all duration-300 ${contactOpen ? 'max-h-24' : 'max-h-0'}`}>
              <Link 
                to="/contact" 
                className="text-left text-gray-600 hover:text-emerald-600 transition-colors text-sm font-medium"
                onClick={closeMobileMenu}
              >
                Contact Form
              </Link>
              <a 
                href="tel:+919630935265" 
                className="text-left text-gray-600 hover:text-emerald-600 transition-colors text-sm font-medium"
                onClick={closeMobileMenu}
              >
                Call Us
              </a>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Navbar;